module.exports = __webpack_public_path__ + "static/pic13-46781068c8092f16df829b19d8ce91e9.jpg";